import {apiCall} from "../../../common/apiActionHandler";
import axios from "axios";

export const getTextMessages = (page, per_page, callback) => async (dispatch, getState) => {
    const config = {
        method: 'GET',
        url: `/api/text_messages/get_text_messages`,
        params: {
            page: page,
            per_page: per_page
        }
    }

    apiCall("Fetching text messages", config, async config => {
        const response = await axios.request(config);
        callback && callback(response.data)
    }, dispatch, getState, false);
};
